import Vue from 'vue'
import Vuex from 'vuex'
import { getCodeRules } from '@/api/system'
Vue.use(Vuex)

const config = {
  state: {
    // 用户信息
    user: {},
    // 个人中心信息
    userCenter:{},
    // 版本信息
    version: {},
    // 版权信息
    copyright: {},
    // 已连接设备
    device: {},
    // 尺寸字典配置
    sizeConfig: [],
    // 扫码配置
    codeRules: [],
    // 原生信息（目前只有安卓）
    appInfo: {}
  },
  getters: {
      user: (state) => state.user,
      userCenter:(state) => state.userCenter,
      version: (state) => state.version,
      copyright: (state) => state.copyright,
      device: (state) => state.device,
      sizeConfig: (state) => state.sizeConfig,
      codeRules: (state) => state.codeRules,
      appInfo: (state) => state.appInfo
  },
  mutations: {
      setUser(state, user) {
        state.user = user
      },
      setUserCenter(state, user) {
        state.userCenter = user
      },
      setVersion(state, version) {
        state.version = version
      },
      setCopyright(state, copyright) {
        state.copyright = copyright
      },
      setDevice(state, device) {
        state.device = device
      },
      setSizeConfig(state, config) {
        state.sizeConfig = config
      },
      setCodeRules(state, codeRules) {
        state.codeRules = codeRules
      },
      setAppInfo(state, appInfo) {
        state.appInfo = appInfo
      },
  },
  actions: {
      setUser: ({commit}, user) => commit('setUser', user),
      setUserCenter: ({commit}, user) => commit('setUserCenter', user),
      setVersion: ({commit}, version) => commit('setVersion', version),
      setCopyright: ({commit}, copyright) => commit('setCopyright', copyright),
      setDevice: ({commit}, device) => commit('setDevice', device),
      setSizeConfig: ({commit}, config) => commit('setSizeConfig', config),
      setCodeRules: ({ commit, state }) => {
        return new Promise(resolve => {
          if (state.codeRules && state.codeRules.length) {
            resolve(state.codeRules)
        } else {
            getCodeRules()
            .then(res => {
              if (res && res.length) {
                commit('setCodeRules', res)
                resolve(res)
              } else {
                resolve([])
              }
            })
        }
        })
      },
      setAppInfo: ({commit}, appInfo) => commit('setAppInfo', appInfo),
  }
}

const store = new Vuex.Store(config)

export default store